import { useEffect } from 'react';
import { prefersReducedMotion } from '../utils/random';

// Subtle 3D tilt that follows the pointer on every [data-tilt] element under rootRef.
const useTiltCards = (rootRef) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root || prefersReducedMotion()) return undefined;

    const cleanups = Array.from(root.querySelectorAll('[data-tilt]')).map((el) => {
      const onMove = (event) => {
        const rect = el.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        // Inline transition keeps the tilt snappy without speeding up the reveal animation.
        el.style.transition = 'transform .12s ease';
        el.style.transform = `perspective(800px) rotateX(${y * -6}deg) rotateY(${x * 8}deg) translateY(-3px)`;
      };
      const onLeave = () => {
        el.style.transition = 'transform .4s ease';
        el.style.transform = '';
      };

      el.addEventListener('mousemove', onMove);
      el.addEventListener('mouseleave', onLeave);
      return () => {
        el.removeEventListener('mousemove', onMove);
        el.removeEventListener('mouseleave', onLeave);
      };
    });

    return () => cleanups.forEach((cleanup) => cleanup());
  }, [rootRef]);
};

export default useTiltCards;
